/**
 * View component for /metrics/:metricId
 *
 * Displays a single metric from the 'byId' map in the metric reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as metricActions from '../metricActions';
import * as metricCategoryActions from '../../metricCategory/metricCategoryActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as sceneActions from '../../scene/sceneActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from "../../../global/components/routing/Breadcrumbs.js.jsx";

// import metric components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';

class SingleMetric extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(metricActions.fetchSingleIfNeeded(match.params.metricId));
    dispatch(metricCategoryActions.fetchListIfNeeded('all'))

    dispatch(contentModuleActions.fetchListIfNeeded('metric', match.params.metricId))
    dispatch(sceneActions.fetchListIfNeeded('metric', match.params.metricId))

  }

  render() {
    const { location, match, metricCategoryStore, metricStore, sceneStore, contentModuleStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual metric object from the map
     */
    const selectedMetric = metricStore.selected.getItem();

    const scenes = sceneStore.util.getList('metric', match.params.metricId)
    const contentModules = contentModuleStore.util.getList('metric', match.params.metricId)

    // build links
    const sceneLinks = scenes ?
      (scenes.map((scene, i) => {
          return (
            <Link to={`/admin/authoring/scenes/${scene._id}`} target={'_blank'} key={scene._id + i}>
              <p>{`Scene: ${scene.title} `}<i className="fa fa-external-link"/></p>
            </Link>
          )
        })
      )
    : null;

    const tmLinks = contentModules ?
      (contentModules.map((cm, i) => {
          return (
            <Link to={`/admin/authoring/content-modules/${cm._id}`} target={'_blank'} key={cm._id + i}>
              <p><b>{`Content Module: ${cm.title} `}<i className="fa fa-external-link"/></b></p>
            </Link>
          )
        })
      )
    : null;

    const isEmpty = (
      !selectedMetric
      || !selectedMetric._id
      || metricStore.selected.didInvalidate
    );

    return (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              {isEmpty ?
                (metricStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: metricStore.selected.isFetching ? 0.5 : 1 }}>
                  <div className="yt-row with-gutters">
                    <div className="yt-col full s_60 m_70">
                      <div className="content-container">
                        <div className="yt-row space-between">
                          <p><strong>Metric details</strong></p>
                          <Link className="yt-btn x-small info" to={`/admin/authoring/metrics/${selectedMetric._id}/update`}>Update metric details</Link>
                        </div>
                        <hr/>
                        <small>
                          <strong>Metric</strong>
                        </small>
                        <p>{selectedMetric.title}</p>
                        <div className="pills">
                          { selectedMetric.survey ? 
                            <div className="pill-item -success">Survey</div>
                            :
                            null 
                          }
                          { selectedMetric.pretest ? 
                            <div className="pill-item -warning">Pre-test</div>
                            :
                            null 
                          }
                        </div>
                        <br/>
                        <small>
                          <strong>Category</strong>
                        </small>
                        <p>{selectedMetric._metricCategory && metricCategoryStore.byId[selectedMetric._metricCategory] ? metricCategoryStore.byId[selectedMetric._metricCategory].title: 'n/a'}</p>
                        <small>
                          <strong>Order</strong>
                        </small>
                        <p>{selectedMetric.order ? selectedMetric.order : 'n/a'}</p>
                        <small>
                          <strong>Likelihood of Deviation (LDO)</strong>
                        </small>
                        <p>{selectedMetric.likelihoodDeviation ? selectedMetric.likelihoodDeviation : 'n/a'}</p>
                        <small>
                          <strong>Impact of Non-Compliance (INC)</strong>
                        </small>
                        <p>{selectedMetric.impactNonCompliance ? selectedMetric.impactNonCompliance : 'n/a'}</p>
                      </div>
                    </div>
                    <div className="yt-col full s_40 m_30">
                      <div className="content-container">
                        <Link
                          className="yt-btn x-small warning"
                          to={`/admin/audit-logs/metric/${selectedMetric._id}`}
                          target="_blank"
                        >
                          Object History &rarr;
                        </Link>
                        
                        {/* <button className="yt-btn x-small success link" onClick={() => this.setState({createLinkModalOpen: true })}><i className="fas fa-plus"/> Add Resource</button> */}
                      </div>
                      <div className="content-container">
                        <p><strong>Metric Usage:</strong></p>
                        <hr/>
                        {tmLinks}
                        <hr/>
                        {sceneLinks}
                      </div>
                      </div>
                  </div>
                </div>
              }
            </div>
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

SingleMetric.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    metricStore: store.metric
    , metricCategoryStore: store.metricCategory
    , sceneStore: store.scene
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleMetric)
);



// WEBPACK FOOTER //
// modules/metric/views/SingleMetric.js.jsx